







































import 'vue-awesome/icons/exchange-alt'
Currency = require 'models/currency.coffee'

export default
  name: 'transaction_current_popover_transfer_from_and_to'
  components:
    balance: require('components/inside/elements/balance.vue').default
  props: ['transaction', 'mode']
  data: ->
    transfer_from_amount: 0
  computed:
    transfer_type: -> if @transaction.isTransferBetweenAccounts() then 'account' else 'virtual'
    categories: ->
      if @transfer_type == 'account'
        if @transaction.isWithHiddenAccount()
          all = @$store.getters.account_categories
        else
          all = @$store.getters.account_categories_visible
      if @transfer_type == 'virtual'
        if @transaction.isWithHiddenVirtual()
          all = @$store.getters.virtual_categories
        else
          all = @$store.getters.virtual_categories_visible
      not_empty = all.filter (cat) => cat.children().length > 0
      return not_empty
    from: -> @$store.getters["#{@transfer_type}s_find"](@transaction.transfer_from_id)
    to:   -> @$store.getters["#{@transfer_type}s_find"](@transaction.transfer_to_id)
    exchange_rate: -> Currency.convert 1, @from.currency, @to.currency
    exchange_rate_description: -> "#{@exchange_rate.toFixed(3)} #{@to.currency.toUpperCase()} = 1 #{@from.currency.toUpperCase()}"
    should_not_transfer_from_reserves: ->
      @$store.getters.forecast != 'surplus' && @transaction.isUnplanned() && @transaction.transfer_from_id == @$store.getters.rs.id
    different_amounts_with_same_currency: -> @from.currency == @to.currency && _.round(@transfer_from_amount) != _.round(@transaction.transfer_to_amount)
  mounted: ->
    @setDefaults()
    @$watch 'transfer_from_amount', => @transaction._transfer_from_amount = @transfer_from_amount
    @$watch 'exchange_rate', => @setTransferToAmount('exchange_rate')
  methods:
    swapFromAndTo: ->
      to_id = @transaction.transfer_to_id
      @transaction.transfer_to_id = @transaction.transfer_from_id
      @transaction.transfer_from_id = to_id
    onInputFromAmount: ->
      @transaction._transfer_from_amount = @transfer_from_amount
      @setTransferToAmount('onInputFromAmount')
    setTransferToAmount: (where) ->
      transfer_to_amount = @transfer_from_amount * @exchange_rate
      if @exchange_rate == 1
        # Don't round if it's the same currency, for example, transferring 1.5 CAD should not round
        @transaction.transfer_to_amount = transfer_to_amount
      else
        # Round if it's not the same currency
        @transaction.transfer_to_amount = Math.round(transfer_to_amount)
    setDefaults: ->
      f = =>
        $input = $(@$el).find("[name='transfer_from_amount']").trigger('change')
        $input.select().focus()
      setTimeout f, 100
      @transfer_from_amount = @transaction.plan_amount if _.isNumber(@transaction.plan_amount)
      @transfer_from_amount = @transaction.real_amount if _.isNumber(@transaction.real_amount)
      @transaction._transfer_from_amount = @transfer_from_amount
      @setTransferToAmount('setDefaults') if !_.isNumber(@transaction.transfer_to_amount)

